import React, { useContext, useState } from "react";
import { Card } from "antd";
import { DatosPersonales } from "./DatosPersonales";
import { Organigrama } from "./Organigrama";
import { SecurityContext } from "context/SecurityContextProvider";

const RUC_SDF = "20330791684";
const RUC_SDF_ENERGIA = "20512436090";

const CardDatosColaborador = () => {
	const [activeTabKey, setActiveTabKey] = useState("datosPersonales");
	const { getUsuarioAutenticado } = useContext(SecurityContext);

	const ruc = getUsuarioAutenticado().empresaSeleccionada?.ruc;
	const ocultarOrganigrama = ruc === RUC_SDF || ruc === RUC_SDF_ENERGIA;

	const tabs = [
		{
			key: "datosPersonales",
			tab: "Datos Personales",
		},
		...(ocultarOrganigrama
			? []
			: [
					{
						key: "organigrama",
						tab: "Organigrama",
					},
			  ]),
	];

	const listaTabs = {
		datosPersonales: <DatosPersonales />,
		organigrama: <Organigrama />,
	};

	const onTabChange = (key) => {
		setActiveTabKey(key);
	};
	return (
		<div>
			<Card
				tabList={tabs}
				activeTabKey={activeTabKey}
				onTabChange={(key) => {
					onTabChange(key);
				}}
				style={{ marginBottom: "30px" }}
			>
				{listaTabs[activeTabKey]}
			</Card>
		</div>
	);
};
export default CardDatosColaborador;
